module.exports = __webpack_public_path__ + "img/footer.607e2d92.png";